import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

// Import Images
import testShape from "../../images/testimonials/shape.png"
import testPic1 from "../../images/testimonials/pic1.jpg"
import testPic2 from "../../images/testimonials/pic2.jpg"
import testPic3 from "../../images/testimonials/pic3.jpg"
import testPic4 from "../../images/testimonials/pic4.jpg"
import testPic5 from "../../images/testimonials/pic5.jpg"
import testPic6 from "../../images/testimonials/pic6.jpg"
import plusOrange from "../../images/shap/plus-orange.png"
import squareBlue from "../../images/shap/square-blue.png"
import circleDots from "../../images/shap/circle-dots.png"
import circleOrange2 from "../../images/shap/circle-orange-2.png"

class testimonialSection extends Component{
	
	render(){
			
		const settings = {
			dots: false,
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
		
		return(
			<>
					
				
				<section className="section-area section-sp3 testimonial-wraper">
					<div className="container">
						<div className="heading-bx text-center">
							<h6 className="title-ext text-secondary">Opiniones</h6>
							<h2 className="title m-b0">Vea lo que dicen los pacientes <br/>sobre nosotros</h2>
						</div>
						<div className="row align-items-center">
							<div className="col-lg-6 text-center">
								<div className="thumb-wraper">
									<img className="bg-img" src={testShape} alt=""/>
									<ul>
										<li data-member="1"><Link to="#"><img src={testPic1} alt=""/></Link></li>
										<li data-member="2"><Link to="#"><img src={testPic2} alt=""/></Link></li>
										<li data-member="3"><Link to="#"><img src={testPic3} alt=""/></Link></li>
										<li data-member="4"><Link to="#"><img src={testPic4} alt=""/></Link></li>
										<li data-member="5"><Link to="#"><img src={testPic5} alt=""/></Link></li>
										<li data-member="6"><Link to="#"><img src={testPic6} alt=""/></Link></li>
									</ul>
								</div>
							</div>
							<div className="col-lg-6">
								<Slider {...settings} className="testimonial-slide">
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Estamos muy agradecidos y satisfechos con la atención del Dr. Eduardo, mi padre tuvo una complicación el día 24 de diciembre a media noche (justo en la cena de navidad) el Dr. lo atendió en urgencias prácticamente de inmediato y lo intervino quirúrgicamente el día 25 de diciembre, nos pareció un trato excelente y profesional. Altamente recomendable, Muchas gracias!</p>
											</div>
											<div className="client-info">
												<h5 className="name">Hector R. Garcia A.</h5>
												<p>Hospital Mac Aguascalientes</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Excelente doctor!! Muy buena atención, me explico todo con detalle, fue amable, profesional, muy rápido y me dio un buen seguimiento.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Evelyn Yuliana Reyes Piña</h5>
												<p>Torre Médica Cmq • Apendicectomia por laparoscopia</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Estuvimos dando vueltas buscando especialistas que pudieran encontrar qué tiene mi esposo y dimos con usted, su servicio es excelente y su dedicación y vocación de doctor ayuda a solucionar problemas difíciles como el de mi marido, totalmente seguro y recomendable.</p>
											</div>
											<div className="client-info">
												<h5 className="name">María Dolores Silva chavez y Eric Morett</h5>
												<p>Torre Médica Cmq • Atención a pacientes con Cirugía Bariátrica</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Excelente como doctor y persona, te da la confianza al momento de realizar la cirugía, te explica con detalle el proceso de la cirugía.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Juan Carlos Montoya</h5>
												<p>Torre Médica Cmq • Cirugía mayor</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
									<div className="slider-item">
										<div className="testimonial-bx">
											<div className="testimonial-content">
												<p>Bastante experiencia en el tema. Una atencion precisa y amable. Muy recomendable el Dr Alvarez. Me realizó una cirugia de vesicula por laparoscopia y en pocos dias tuve una mejoria muy notoria.</p>
											</div>
											<div className="client-info">
												<h5 className="name">Emmanuel Rodriguez Jimenez</h5>
												<p>Torre Médica Cmq • Colecistectomia por laparotomia</p>
											</div>
											<div className="quote-icon">
												<i className="fas fa-quote-left"></i>
											</div>
										</div>
									</div>
								</Slider>
							</div>	 
						</div>	 
					</div>
					<img className="pt-img1 animate1" src={plusOrange} alt=""/>
					<img className="pt-img2 animate2" src={squareBlue} alt=""/>
					<img className="pt-img3 animate3" src={circleDots} alt=""/>
					<img className="pt-img4 animate4" src={circleOrange2} alt=""/>
				</section>
				
			</>
		);
	}
}

export default testimonialSection;